import routes from "@/routes";
import { lazy } from "react";

const CampaignStatsBeta = lazy(() => import("@/modules/Report/CampaignStatsBeta"));

const CampaignStatsBetaRoutes = {
  element: <CampaignStatsBeta />,
  path: routes.REPORTS.STATS_BETA.INDEX,
};

export default CampaignStatsBetaRoutes;
